import React from 'react';

export default props => {
    return <div className="ProgressBackground">
        <div style={{
                width: (props.value * 100).toString() + '%',
                backgroundColor: props.color
            }}></div>
    </div>
}
